import {ApiService} from "./ApiService";
import UrlEndpoints from "./UrlEndpoints";
import {store} from '../index';
import {storeUserInfo, clearUserInfo} from "../actions/UserInfoActions";

export default class DashboardService {

    static async getPremise(userInfo) {
        const body = {
            "emailOrMac": userInfo
        };
        const accountInfo = await ApiService.post(UrlEndpoints.TOPOLOGY, body);
        if(accountInfo.error){
            throw new Error(accountInfo.message);
        }
        await store.dispatch(storeUserInfo(accountInfo.premises));
        return accountInfo.email;
    }

    static async clearReduxData(){
        // add clear data methods for all the reducers that will be added in future
        this.clearUserData();
    }

    static async clearUserData(){
        await store.dispatch(clearUserInfo());
    }

    static upgradeDevice(request) {
        ApiService.post(UrlEndpoints.UPGRADE_BUILD, request)
    }

    static restartDevice(macId) {
        ApiService.post((UrlEndpoints.REBOOT).replace("macId", macId));
    }

    static unpairDevice(deviceId) {
        ApiService.delete((UrlEndpoints.UNPAIR).replace("deviceId", deviceId));
    }

    static getPirDataForDevice(macId) {
        ApiService.post((UrlEndpoints.PIR_DEBUG).replace("macId", macId));
    }

    static getScheduleProfile(macId) {
		const schedulesprofiles = ApiService.get((UrlEndpoints.SCHEDULE_PROFILE).replace("macId", macId));
        return schedulesprofiles;
    }

    static getSchedules(macId) {
        const schedules = ApiService.get((UrlEndpoints.SCHEDULE).replace("macId", macId));
        return schedules;
    }

    static getScenes(macId) {
        const scenes = ApiService.get((UrlEndpoints.SCENE).replace("macId", macId));
        return scenes;
    }

    static getGlobalSettings(macId) {
        const settings = ApiService.get((UrlEndpoints.GLOBAL_SETTINGS).replace("{mac}", macId));
        return settings;
    }

    static async factoryResetDevice(mac) {
        return await ApiService.post((UrlEndpoints.FACTORY_RESET_DEVICE).replace("mac", mac));
    }

    static async activateDevice(mac) {
        return await ApiService.post((UrlEndpoints.ACTIVATE_DEVICE).replace("mac", mac));
    }

    static async deactivateDevice(mac) {
        return await ApiService.post((UrlEndpoints.DEACTIVATE_DEVICE).replace("mac", mac));
    }

    static async getGroups(macId) {
        const groups = await ApiService.get((UrlEndpoints.GROUP).replace("macId", macId));
        return groups;
    }
}
